<template>
  <section class="product-review-home" :style="componentStyles">
    <swiper
      :slides-per-view="1"
      class="product-review-home__image-slider"
      ref="imageSwiper"
    >
      <swiper-slide v-for="block in schema.blocks" :key="block.id" class="product-review-home__slide">
        <a
          :href="`/products/${block.product.handle}`"
          class="product-review-home__product-link"
        >
          <div class="product-review-home__image-container">
            <img
              :src="imageSize(block.product.featured_image, '200x')"
              class="product-review-home__product-image"
            />
            <div class="product-review-home__brand-name">
              {{ block.product.vendor }}
            </div>
            <div class="product-review-home__product-name">
              {{ block.product.title }}
            </div>
          </div>
        </a>
      </swiper-slide>
    </swiper>

    <swiper
      :slides-per-view="1"
      class="product-review-home__slider"
      :options="desktopOptions"
      ref="swiperReview"
    >
      <swiper-slide v-for="block in schema.blocks" :key="block.id">
        <article class="product-review-home__container">
          <div class="product-review-home__review-body">
            <div class="rating" :style="starStyles">
              <icon
                name="review-star"
                v-for="counter in Number(block.settings.review_rating)"
                :key="counter"
              />
            </div>
            <blockquote class="product-review-home__review-content h6" :style="contentStyles">
              <span v-html="block.settings.reviews_body"></span>
            </blockquote>
            <div class="product-review-home__footer">
              <p class="product-review-home__reviewer-name" :style="contentStyles">{{ block.settings.review_source }}</p>
              <p class="product-review-home__verified-buyer" :style="contentStyles">Verified Buyer</p>
            </div>
          </div>
        </article>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev">
        <span>
          <icon name="secondary_arrow_left_white" size="9px"></icon>
        </span>
      </div>
      <div class="swiper-button-next" slot="button-next">
        <span>
          <icon name="secondary_arrow_right_white" size="9px"></icon>
        </span>
      </div>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    
  </section>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { imageSize, imageCrop, checkUndefined } from "../../helpers/util";
import { px } from "@/scripts/filters/string.js";
import Icon from "@/scripts/components/basic/Icon.vue";

export default {
  name: "ProductReviewHome",
  props: {
    schema: Object,
  },
  components: {
    swiper,
    swiperSlide,
    Icon
  },
  data() {
    return {
      heightString: '400px',
      textColor: this.schema.settings.textColor,
      starColor:  this.schema.settings.starColor,
      slideIndex: 0,
      desktopOptions: {
        slidesPerView: "auto",
        loop: true,
        initialSlide: 0,
        autoHeight:true,
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: () => {
            this.slideIndex = this.$refs.swiperReview.swiper.realIndex;
            this.slide(this.slideIndex);
          }
        }
      }
    };
  },
  computed: {
    componentStyles() {
      let componentStyle = {
        backgroundColor: this.schema.settings.backgroundColor,
      };

      if (this.schema.settings.backgroundImage) {
        componentStyle.backgroundImage =
          this.$mq === "mobile"
            ? `url(${this.schema.settings.backgroundImageMobile})`
            : `url(${this.schema.settings.backgroundImage})`;
      }

      return componentStyle;
    },
    contentStyles() {
     return {
        "color": this.textColor
      };
    },
    starStyles() {
     return {
        "color": this.starColor
      };
    },
    paddingStyles() {
      return {
        "padding-top": px(checkUndefined(this.schema.settings.marginTop, 56)),
        "margin-bottom": px(
          checkUndefined(this.schema.settings.marginBottom, 56)
        ),
      };
    },
  },
  methods: {
    imageSize,
    slide(index) {
      this.$refs.imageSwiper.swiper.slideTo(index);
    }
  }
};
</script>

<style lang="scss" scoped>

.product-review-home {
  position: relative;
  padding: 80px 28px;

  &__review-body {
    text-align: center;
    max-width: 750px;
    margin: 0 auto;
  }

  &__image-slider {
    max-width: 200px;
    background: $color-black-050;
    position: absolute;
    top: -100px;
    left: 20%;
    border-radius: calc(200px / 2);
    min-height: 327px;
    text-align: center;
    z-index: 2;
    @include mobile-only {
      max-width: 163px;
      min-height: 250px;
      top: -160px;
      left: 50px;
    }
  }
  &__brand-name {
    color: $color-black-700;
    font-family: $font-family-secondary;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 16px;
    @include mobile-only {
      font-size: 12px;
    }
  }
  &__product-name {
    color: $color-tundora;
    font-family: $font-family-secondary;
    font-size: 17px;
    letter-spacing: 0;
    line-height: 25px;
    @include mobile-only {
      font-size: 12px;
    }
  }
  &__product-link {
    text-decoration: none;
    color: inherit;
  }
  &__slider {
    margin-top: 124px;
    max-width: 1050px;
    @include mobile-only {
      margin-top: 45px;
      .swiper-button-next,
      .swiper-button-prev {
        display: none;
      }
    }
  }

  &__review-content {

    @include h6-desktop;
    margin: 30px 0;
    text-align: center;

    @include mobile-only {
      @include h7-mobile;
      margin-top: 24px;
      margin-bottom: 32px;
      line-height: 29px;
    }
  }

  &__reviewer-name {
    font-family: $font-family-secondary;
    font-size: 17px;
    font-weight: 600;
    letter-spacing: -0.11px;
    line-height: 23px;
    @include mobile-only {
      font-size: 14px;
    }
  }
  &__verified-buyer {
    font-family: $font-family-secondary;
    font-size: 15px;
    letter-spacing: -0.1px;
    line-height: 23px;
    font-weight: $font-weight-global;
    @include mobile-only {
      font-size: 12px;
    }
  }
}

.swiper-pagination {
  position: unset;
  margin-top: 30px;
  @include mobile-only {
     margin-top: 29px;
  }

}
.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
  display: none;
}
.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  display: none;
}
.swiper-button-prev {
  height: 60px;
  width: 60px;
  border-radius: 60px;
  border: 1px solid $color-white;
  left: 0px;
  top: 33%;
  span {
    position: relative;
    width: 24px;
    &:after {
      height: 1px;
      display: block;
      content: "";
      background-color: $color-white;
      position: absolute;
      width: 100%;
    }
  }
  svg {
    position: absolute;
    top: -4px;
    left: -2px;
  }
}
.swiper-button-next {
  height: 60px;
  width: 60px;
  border-radius: 60px;
  border: 1px solid $color-white;
  right: 0px;
  top: 33%;
  span {
    position: relative;
    width: 24px;
    &:after {
      height: 1px;
      display: block;
      content: "";
      background-color: $color-white;
      position: absolute;
      width: 100%;
    }
  }
  svg {
    position: absolute;
    top: -4px;
    right: -2px;
  }
}
/deep/ .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  border: 1px solid $color-white;
  opacity: 0.7;
  background: $color-white;
  margin: 0 2px;
  &:first-child {
    margin-left: 0;
  }
}
/deep/ .swiper-pagination-bullet-active {
  opacity: 1;
  background: $color-white;
  border-color: $color-white;
}
/deep/ .product-review-home__slide.swiper-slide {
  height: auto;
  img {
    display: block;
  }
}
</style>
